import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WithOnboardingAnalyticsCategory } from './onboardingAnalytics';
import META from './useTrackViewedOnboardingSize.meta';

export type ViewedOnboardingSizeParams = WithOnboardingAnalyticsCategory;

export const useTrackViewedOnboardingSize = () => {
  const { track } = useAnalyticsUtilities();

  const trackViewedOnboardingSize = useCallback(
    (params: ViewedOnboardingSizeParams) => {
      track(META.name, params, { integrations: { Intercom: true } });
    },
    [track],
  );

  return { trackViewedOnboardingSize };
};
